module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/reset-mob/reset-mob.component.css
// module id = ./src/app/shared/reset-mob/reset-mob.component.css
// module chunks = main